__turbopack_context__.v({
  "additionalOpenInfo": "ContactInfoSection-module-scss-module__1h_SNq__additionalOpenInfo",
  "contactInfoBlock": "ContactInfoSection-module-scss-module__1h_SNq__contactInfoBlock",
  "contactInfoSection": "ContactInfoSection-module-scss-module__1h_SNq__contactInfoSection",
  "contactPhone": "ContactInfoSection-module-scss-module__1h_SNq__contactPhone",
  "content": "ContactInfoSection-module-scss-module__1h_SNq__content",
  "description": "ContactInfoSection-module-scss-module__1h_SNq__description",
  "descriptionBlock": "ContactInfoSection-module-scss-module__1h_SNq__descriptionBlock",
  "icon": "ContactInfoSection-module-scss-module__1h_SNq__icon",
  "icons": "ContactInfoSection-module-scss-module__1h_SNq__icons",
  "link": "ContactInfoSection-module-scss-module__1h_SNq__link",
  "mail": "ContactInfoSection-module-scss-module__1h_SNq__mail",
  "openInfo": "ContactInfoSection-module-scss-module__1h_SNq__openInfo",
  "openInfoBlock": "ContactInfoSection-module-scss-module__1h_SNq__openInfoBlock",
  "title": "ContactInfoSection-module-scss-module__1h_SNq__title",
});
